import { useCallback, useState } from 'react';
import {
  createCustomer,
  CustomerCreateResult,
  NewCustomerPayload,
} from '../services/customerCreateApi';
import { invalidateCustomerIndexCache } from '../services/customerIndexCacheService';

export interface UseCreateCustomerResult {
  isSaving: boolean;
  error: string | null;
  submit: (payload: NewCustomerPayload) => Promise<CustomerCreateResult>;
  reset: () => void;
}

export function useCreateCustomer(): UseCreateCustomerResult {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (payload: NewCustomerPayload) => {
    setIsSaving(true);
    setError(null);
    try {
      const result = await createCustomer(payload);
      invalidateCustomerIndexCache();
      return result;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to create customer';
      setError(message);
      throw err;
    } finally {
      setIsSaving(false);
    }
  }, []);

  const reset = useCallback(() => setError(null), []);

  return { isSaving, error, submit, reset };
}
